<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="sequence-assign-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form
        ref="form"
        class="sequence-assign-form"
        @submit.prevent="onSubmit"
      >
        <div class="sequence-assign-form-body">
          <v-toolbar flat height="76">
            <v-toolbar-title class="sequence-assign-toolbar-title"
              >Assign to</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn color="accent" icon tile @click="closeDialog">
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container class="new-practice-card-container">
            <bh-text-input
              :no-margin="true"
              higher
              placeholder="Search participants"
              inputBackgroundClass="bhWhite"
              roundedClass="rounded"
              @input-text="searchRun"
            />
          </v-container>
          <v-container class="new-practice-card-container pt-0">
            <div class="sequence-assign-patients">
              <main-user-table
                :headers="headers"
                :items="computedParticipants"
                :selectItems="practiceUserPatients"
                :items-per-page="queryParams.pageSize"
                :server-items-length="
                  practiceUserPatientsPagination.totalCount || -1
                "
                :page="queryParams.page"
                :row-component="'sequence-assign-participant-table-row'"
                @select-participant="selectParticipant"
                @action:get-data="getParticipants"
              />
            </div>
          </v-container>
        </div>
        <div class="sequence-assign-footer">
          <v-container class="new-practice-card-container pt-0 pb-4">
            <v-row>
              <v-col>
                <dialog-date-picker
                  label="Start date"
                  name="startDate"
                  :value="sequenceStartDate"
                  :initial-date="$moment().format('YYYY-MM-DD')"
                  @input="setDate"
                />
              </v-col>
              <v-col>
                <v-btn
                  :disabled="!formIsValidCheck"
                  absolute
                  bottom
                  right
                  elevation="0"
                  rounded
                  color="accent"
                  :loading="isLoading"
                  @click="assignParticipants"
                  >Assign</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import MainUserTable from '@/components/tables/MainUserTable'
import BhTextInput from '@/components/inputs/BhTextInput.vue'
import DialogDatePicker from '@/components/forms/DialogDatePicker.vue'
import RouterMixin from '@/mixins/router'
import { debounce } from '@/helpers/debounce'

export default {
  name: 'SequenceAssignDialog',
  components: {
    MainUserTable,
    BhTextInput,
    DialogDatePicker,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [RouterMixin],
  data() {
    return {
      dialog: false,
      headers: [],
      selectedParticipants: [],
      sequenceStartDate: false,
      formIsValidCheck: false,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
        this.sequenceStartDate = this.$moment().format('YYYY-MM-DD')
        this.getDataAction(
          { ...this.queryParams, practiceUserId: this.profileId },
          false,
        )
      }
    },
  },
  computed: {
    ...mapState('practicesStates', [
      'practiceUser',
      'practiceUserPatients',
      'practiceUserPatientsPagination',
    ]),
    ...mapState('dictionariesStates', [
      'dictionaryPracticeUserRole',
      'dictionaryBhUsersRoleIds',
    ]),
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('userStates', ['profileId']),
    isPermitted() {
      if (
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Administrator &&
        this.practiceUser.profileId != this.profileId
      )
        return true
      else if (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
        this.dictionaryBhUsersRoleIds.Admin
      )
        return true
      else return false
    },
    computedParticipants() {
      let participants = []
      this.practiceUserPatients.forEach(item => {
        let selected = false
        if (this.selectedParticipants.includes(item.id)) selected = true
        participants.push({ selected: selected, ...item })
      })
      return participants
    },
  },
  methods: {
    ...mapActions('practicesStates', ['getPracticeUserPatients']),
    getData(data = {}) {
      if (this.dialog) this.getPracticeUserPatients(data)
    },
    closeDialog() {
      this.dialog = false
      this.editedUser = { practiceId: this.practiceId }
      this.userToSave = {}
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    clearForm() {
      this.$refs.form.reset()
    },
    onSubmit() {
      this.$emit('on-submit', this.selectedParticipants)
      this.editedUser = { practiceId: this.practiceId }
      this.userToSave = {}
      this.closeDialog()
    },
    searchRun(text) {
      debounce(
        () => {
          this.getDataAction({ ...this.queryParams, fullName: text }, false)
          this.selectedParticipants = []
          this.formIsValid()
        },
        500,
        'getParticipants',
      )
    },
    selectParticipant(id) {
      if (this.selectedParticipants.includes(id))
        this.selectedParticipants.splice(
          this.selectedParticipants.indexOf(id),
          1,
        )
      else this.selectedParticipants.push(id)
      this.formIsValid()
    },
    setDate({ id, value }) {
      this.sequenceStartDate = value
      this.formIsValid()
    },
    formIsValid() {
      if (!this.sequenceStartDate || this.selectedParticipants.length == 0)
        this.formIsValidCheck = false
      else this.formIsValidCheck = true
    },
    assignParticipants() {
      if (this.formIsValidCheck)
        this.$emit(
          'assign-participants',
          this.selectedParticipants,
          this.sequenceStartDate,
        )
    },
    getParticipants(data) {
      debounce(
        () => {
          this.getDataAction(
            {
              ...this.queryParams,
              ...data,
              ...{ practiceUserId: this.practiceUser.id },
            },
            false,
          )
        },
        500,
        'getParticipants',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.sequence-assign {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-weight: bold;
  }
  &-tabs {
    padding: 0 24px;
    background: #ffffff;
    .v-tab {
      color: $bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color: white;
      }
    }
    .v-tabs-slider {
      background: $bh-blue;
    }
  }
  &-v-tabs-items {
    background: $bh-blue--4 !important;
  }

  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
  &-form {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 0;
    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
  }
  &-user-patients {
    padding: 12px 24px;
  }
}
</style>
